import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import { teliacloudtheme } from '../teliacloud/teliacloud.theme'

import './theme.css'

export const teliaskytheme: BrandTheme = merge.all<
  BrandTheme,
  PartialBrandTheme
>(teliacloudtheme, {
  branding: {
    brand: 'GET',
    themedir: dirname(new URL(import.meta.url).pathname),
    appIconSvg: './appicon.svg',
    favIconSvg: './favicon.svg',
    staticDir: 'telia_sky',
    height: 32,
    learnMoreLinkWaitlist: 8415149,
    learnMoreLinkSearch: 8415289,
  },
})
export default teliaskytheme
